import {ActionTypes} from '../../actions';
import createReducer from '../../../common/util/createReducer';

const INITIAL_STATE = {
  'list': [],
  'loading': false,
};

export const wtsCertificacion = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCHING_WTS_CERTIFICACION]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_WTS_CERTIFICACION]: (state, action) => ({
      ...state,
      'loading': false,
      'list': action.response.data,
    }),
    [ActionTypes.FETCHED_WTS_CERTIFICACION_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'list': [],
    }),
    [ActionTypes.CREATING_WTS_CERTIFICACION]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.CREATED_WTS_CERTIFICACION]: (state, action) => ({
      ...state,
      'loading': false,
    }),
    [ActionTypes.CREATED_WTS_CERTIFICACION_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
    }),
    [ActionTypes.UPDATING_WTS_CERTIFICACION]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.UPDATED_WTS_CERTIFICACION]: (state, action) => ({
      ...state,
      'loading': false,
    }),
    [ActionTypes.UPDATED_WTS_CERTIFICACION_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
    }),
    [ActionTypes.DELETING_WTS_CERTIFICACION]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.DELETED_WTS_CERTIFICACION]: (state, action) => ({
      ...state,
      'loading': false,
    }),
    [ActionTypes.DELETED_WTS_CERTIFICACION_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
    }),
  })(state, action);
};
